<template>
  <div>
    <div>
      <h3>Site Information - Getting Started</h3>
    </div>
    <div class="wrapper">
      <div class="row row-wider">
        <div class="col-md-12" style='margin-bottom: 20px;'>
            See below links for guides and information to help you get started.
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://docs.google.com/document/d/1wHfTm_Pu-sYCWYwFP1d7Htt4hlPyOCbAsSY6mFeoeU8/edit?usp=sharing"
                target="_blank">WyoTrack News</a>
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://docs.google.com/document/d/1UeQ2Fdu6gBZJpVAMaCBt7ih2pcDAMpkcjVVYJvk6wdA/edit?usp=sharing"
                target="_blank">User Manual</a>
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://docs.google.com/document/d/1mV4Pk9G6zp1DQfa-fqfyaY6oj0M5pKPXdDN3xwDoPL4/edit"
                target="_blank">GIS Manual</a>
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://drive.google.com/file/d/1ghp2d3_oaKg_DvJQxufXlXWvIkKQSJOl/view?usp=sharing"
                target="_blank">CR Risk Layer Map Guide</a>
        </div>
        <!-- <div class="col-md-12" v-if="isAgency" style='margin: 10px;'>
            <a href="https://docs.google.com/document/d/1H0k0kngjAlNKZIKyqrYv2TI8ZOW2Ut7HmUhin9y0uME/edit"
                target="_blank">Agency User Manual</a>
        </div> -->
        <div class="col-md-12" style='margin-top: 20px;'>
            GIS Resources:
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://drive.google.com/a/gannettpeaktech.com/file/d/1Ta9pJr1eDM9xMzZaCPRUzK5tjm8LI-ha/view?usp=sharing"
                target="_blank">GIS XML Template</a>
        </div>
        <div class="col-md-12" style='margin: 10px;'>
            <a href="https://drive.google.com/a/gannettpeaktech.com/file/d/15PpZcVPNFStuxxcQE_v9BMjmtmuN_UfZ/view?usp=sharing"
                target="_blank">GIS Template Zip</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import userService from '../services/userService'
import roleService from '../services/roleService'
import { mapState } from 'vuex'

export default {
    name: 'helpInfo',
    data: function () {
        return {
            isDebug: false,
            result: [],
            verifyAlertHidden: true,
            verifyAlertMessage: '',
            alertType: 'alert-success'
        }
    },
    computed: {
        ...mapState({
            authenticated: state => state.auth.authenticated,
            profile: state => state.auth.shpoProfile,
            shpoUserDto: state => state.auth.shpoUserDto,
            authResult: state => state.auth.authResult
        }),
        isAgency: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList.concat(roleService.AgencyRoleList))
        }
    },
    mounted () {
    },
    methods: {
    }
}
</script>
<style>

.text-label {
    line-height: 24px !important;
}

</style>



// WEBPACK FOOTER //
// HelpInfo.vue?1073aa11